import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useSelector } from 'react-redux';
import { SALES_SEAT, SERVICE_SEAT } from 'self-service-api/constants/UnitNames';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { includedCoreSeatsQuantityForProductVersionSelector, includedSeatQuantityBySkuIdSelector, productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { useAdditionalCoreSeatPrice, useShowAdditionalSeatsPriceSubtext, useShowIncludedSeats } from './seats-display/useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IncludedSeatsDisplay = ({
  skuId
}) => {
  const includedCoreSeats = useAppSelector(state => {
    return includedCoreSeatsQuantityForProductVersionSelector(state, {
      productVersionSkuId: skuId
    });
  });
  const includedSalesSeats = useAppSelector(state => {
    return includedSeatQuantityBySkuIdSelector(state, {
      skuId,
      seatUnitName: SALES_SEAT
    });
  });
  const includedServiceSeats = useAppSelector(state => {
    return includedSeatQuantityBySkuIdSelector(state, {
      skuId,
      seatUnitName: SERVICE_SEAT
    });
  });
  const includedSeats = includedCoreSeats + includedSalesSeats + includedServiceSeats;
  const {
    apiName,
    productLevel
  } = useSelector(state => {
    return productForSkuIdSelector(state, {
      skuId
    });
  });
  const currencyCode = useDisplayedCurrencyCode();
  const showIncludedSeats = useShowIncludedSeats({
    skuId
  });
  const showAdditionalSeatsPriceSubtext = useShowAdditionalSeatsPriceSubtext({
    skuId
  });
  const {
    additionalCoreSeatsPrice
  } = useAdditionalCoreSeatPrice({
    skuId
  });
  if (!showIncludedSeats && !showAdditionalSeatsPriceSubtext) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [showIncludedSeats && /*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `merchCards.pricing.includes.seats.${productLevel}`,
        options: {
          count: includedSeats
        }
      })
    }), showAdditionalSeatsPriceSubtext && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "merchCards.pricing.subtexts.additionalSeatsStartAt_jsx",
      options: {
        seleniumId: apiName,
        currencyCode,
        additionalSeatsPrice: additionalCoreSeatsPrice
      },
      elements: {
        PriceDisplay
      }
    })]
  });
};
export default IncludedSeatsDisplay;